import { FC } from 'react'
import { Form } from 'react-bootstrap'
import { FieldProps } from '../Forms.d'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'
import { useAppSelector } from '../../../../store/hooks'

const ColourField: FC<FieldProps> = ({
    id,
    label = '',
    showLabel = true,
    name,
    formikProps,
    placeholder = '',
    groupClassName = '',
    className = '',
    required = false,
    disabled = false,
    readonly = false,
    onBlur,
}) => {
    const theme = useAppSelector((state) => state.theme.theme)
    const { values, errors, handleChange } = formikProps

    return (
        <Form.Group
            className={
                (groupClassName || '') +
                ' sfy-field mb-3' +
                (required ? ' required' : '')
            }
            controlId={id}
        >
            {showLabel && (
                <Form.Label>
                    {label}{' '}
                    {required && (
                        <FontAwesomeIcon
                            icon={faAsterisk}
                            className="text-danger"
                            size="xs"
                        />
                    )}
                </Form.Label>
            )}
            <Form.Control
                type="color"
                name={name}
                value={
                    values[name] || (theme === 'dark' ? '#000000' : '#FFFFFF')
                }
                onChange={handleChange}
                onBlur={(e) => {
                    if (onBlur) onBlur(e)
                }}
                placeholder={placeholder}
                className={
                    'w-100 ' +
                    (className || '') +
                    ' ' +
                    (errors[name] ? 'is-invalid' : '') +
                    (readonly ? ' readonly' : '')
                }
                disabled={disabled}
                readOnly={readonly}
                autoComplete={name + '-' + new Date().getMilliseconds()}
            />
            <span className="bottom-border"></span>
            {errors[name] && (
                <Form.Text className="invalid-feedback">
                    {errors[name].toString()}
                </Form.Text>
            )}
        </Form.Group>
    )
}

export default ColourField
